// tabs goods
if(document.querySelector('.tab-h')){
    let tabsWrapper = document.querySelectorAll('.tabs-wrapper');
    let tabItem;
    tabsWrapper.forEach(function (element) {
        tabItem = element.querySelectorAll('.tab-h');
        tabItem.forEach(function (item) {
            item.addEventListener('click',fTabs);
        });
        function fTabs(event) {
            tabItem = element.querySelectorAll('.tab-h');
            tabItem.forEach(function (item) {
                item.classList.remove('active');
            })
            this.classList.add('active');
            let datatab = this.dataset.tab;
            let tabBody = element.getElementsByClassName('tab-b');
            for (let i = 0; i < tabBody.length; i++) {
                if (datatab == i) {
                    tabBody[i].style.display = 'block';
                }
                else{
                    tabBody[i].style.display = 'none';
                }
            }
        }
    })
}